class LocationInventory extends HTMLElement {
  connectedCallback() {
    // Avoid double init
    if (this.__initialized) return;
    this.__initialized = true;
    this.#fetchAndRender().catch(() => this.#applyState(false));
  }

  async #fetchAndRender() {
    const apiUrl = this.dataset.storefrontApiUrl;
    const token = this.dataset.storefrontToken;
    const productId = this.dataset.productId;
    const variantId = this.dataset.variantId;
    if (!apiUrl || !token || !productId) return;

    const query = `query Availability($productId: ID!) {
      product(id: $productId) {
        id
        title
        variants(first: 100) {
          nodes {
            id
            title
            availableForSale
            storeAvailability(first: 10) {
              nodes {
                location { id name }
                available
                quantityAvailable
              }
            }
          }
        }
        selectedOrFirstAvailableVariant {
          id
          storeAvailability(first: 1) {
            nodes {
              location {
                id
                name
              }
              available
              quantityAvailable
            }
          }
        }
      }
    }`;

    const res = await fetch(apiUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': token
      },
      body: JSON.stringify({ query, variables: { productId: `gid://shopify/Product/${productId}` } })
    });

    const json = await res.json();
    console.log(json);
    const variantGid = variantId ? `gid://shopify/ProductVariant/${variantId}` : null;
    const variantsList = json?.data?.product?.variants?.nodes || [];
    const matchedVariant = variantsList.find((v) => v?.id === variantGid);
    const nodes =
      matchedVariant?.storeAvailability?.nodes ??
      (json?.data?.product?.selectedOrFirstAvailableVariant?.storeAvailability?.nodes || []);

    const hasLocationData = Array.isArray(nodes) && nodes.length > 0;
    if (!hasLocationData) {
      const anyAvailableFallback = matchedVariant
        ? !!matchedVariant.availableForSale
        : !!json?.data?.product?.selectedOrFirstAvailableVariant?.availableForSale;
      // quantityAvailable = null để hiển thị “Available”
      this.#applyState(anyAvailableFallback, '', false, null);
      return;
    }
    const preferred = nodes.find((/** @type {{location?: {name?: string}}} */ n) => n?.location?.name === 'Better Music');
    const threshold = parseInt(this.dataset.threshold || '10', 10);
    
    // Get availability and quantity from preferred location or first available
    const locationData = preferred || nodes.find((/** @type {{available?: boolean}} */ n) => n?.available === true) || nodes[0];
    const anyAvailable = locationData?.available ?? false;
    const quantityAvailable = locationData?.quantityAvailable ?? 0;
    const locationName = locationData?.location?.name ?? 'Better Music';
    
    // Determine if low stock (available but quantity below threshold)
    const isLowStock = anyAvailable && quantityAvailable > 0 && quantityAvailable < threshold;
    
    this.#applyState(anyAvailable, locationName, isLowStock, quantityAvailable, threshold);
  }

  /**
   * @param {boolean} anyAvailable
   * @param {string} locationName
   * @param {boolean} isLowStock
   * @param {number} quantityAvailable
   */
  #applyState(anyAvailable, locationName = 'Better Music', isLowStock = false, quantityAvailable, threshold = 0) {
    const textEl = this.querySelector('.product-inventory__text');
    const iconEl = this.querySelector('.product-inventory__icon');
    const countinue = this.dataset.continue;
    if (!textEl || !iconEl) return;

    iconEl.classList.remove(
      'product-inventory__icon-in_stock',
      'product-inventory__icon-out_of_stock',
      'product-inventory__icon-low'
    );
    const noQuantityTracking = anyAvailable && (quantityAvailable === null || quantityAvailable === undefined);

    if (isLowStock) {
      iconEl.classList.add('product-inventory__icon-low');
      textEl.textContent = `${quantityAvailable} in stock`;
    } else if (noQuantityTracking) {
      iconEl.classList.add('product-inventory__icon-in_stock');
      textEl.textContent = `Available`;
    } else if (anyAvailable && quantityAvailable > 0) {
      iconEl.classList.add('product-inventory__icon-in_stock');
      textEl.textContent = `${threshold - 1}+ in stock`;
    } else if (quantityAvailable == 0 && countinue) {
      iconEl.classList.add('product-inventory__icon-out_of_stock');
      textEl.textContent = `Backorder`;
    } else {
      iconEl.classList.add('product-inventory__icon-out_of_stock');
      textEl.textContent = `Out of stock - ${locationName}`;
    }
  }
}

if (!customElements.get('location-inventory')) {
  customElements.define('location-inventory', LocationInventory);
}


